import { PERSONA_ORDER, PERSONAS, type PersonaId } from '../ai/personas';

export interface HUDState {
  planesLeft: number;
  hint: string;
  aimPower: number | null;
  lockedPersona: PersonaId | null;
}

export class HUD {
  private root: HTMLDivElement;
  private planesEl: HTMLSpanElement;
  private progressEl: HTMLSpanElement;
  private hintEl: HTMLDivElement;
  private aimEl: HTMLDivElement;
  private aimFillEl: HTMLDivElement;
  private personaListEl: HTMLDivElement;
  private celebrationEl: HTMLDivElement;

  constructor(host: HTMLElement) {
    this.root = document.createElement('div');
    this.root.className = 'layer hud hidden';
    this.root.innerHTML = `
      <div class="hud-top">
        <div class="hud-counter">
          纸飞机 <span class="hud-count">∞</span>
          <span class="hud-progress" aria-label="收集进度">0/${PERSONA_ORDER.length}</span>
        </div>
        <div class="hud-personas"></div>
      </div>
      <div class="hud-celebration"></div>
      <div class="hud-aim"><div class="hud-aim-fill"></div></div>
      <div class="hud-hint">滑动屏幕蓄力 · 松手投出</div>
    `;
    host.appendChild(this.root);
    this.planesEl = this.root.querySelector('.hud-count') as HTMLSpanElement;
    this.progressEl = this.root.querySelector('.hud-progress') as HTMLSpanElement;
    this.hintEl = this.root.querySelector('.hud-hint') as HTMLDivElement;
    this.aimEl = this.root.querySelector('.hud-aim') as HTMLDivElement;
    this.aimFillEl = this.root.querySelector('.hud-aim-fill') as HTMLDivElement;
    this.personaListEl = this.root.querySelector('.hud-personas') as HTMLDivElement;
    this.celebrationEl = this.root.querySelector('.hud-celebration') as HTMLDivElement;
    this.renderPersonas();
  }

  private renderPersonas(): void {
    this.personaListEl.innerHTML = PERSONA_ORDER.map(pid => {
      const p = PERSONAS[pid];
      return `<div class="hud-persona" data-pid="${pid}" title="${p.name}"><span>${p.emoji}</span></div>`;
    }).join('');
  }

  show(): void {
    this.root.classList.remove('hidden');
  }

  hide(): void {
    this.root.classList.add('hidden');
  }

  setVisited(set: Set<PersonaId>): void {
    this.personaListEl.querySelectorAll<HTMLDivElement>('.hud-persona').forEach(el => {
      const pid = el.dataset.pid as PersonaId;
      el.classList.toggle('visited', set.has(pid));
    });
    this.progressEl.textContent = `${set.size}/${PERSONA_ORDER.length}`;
  }

  pulseSlot(personaId: PersonaId): void {
    const el = this.personaListEl.querySelector<HTMLDivElement>(`.hud-persona[data-pid="${personaId}"]`);
    if (!el) return;
    el.classList.add('pulse');
    setTimeout(() => el.classList.remove('pulse'), 1500);
  }

  showFirstMeet(personaId: PersonaId): void {
    const p = PERSONAS[personaId];
    this.celebrationEl.innerHTML = `<div class="hud-celeb-card"><div class="hud-celeb-emoji">${p.emoji}</div><div class="hud-celeb-text">初次相遇 · ${p.shortName}</div></div>`;
    this.celebrationEl.classList.add('show');
    setTimeout(() => this.celebrationEl.classList.remove('show'), 1500);
  }

  showAchievement(text: string): void {
    this.celebrationEl.innerHTML = `<div class="hud-celeb-card hud-celeb-achievement"><div class="hud-celeb-emoji">🌕</div><div class="hud-celeb-text">${text}</div></div>`;
    this.celebrationEl.classList.add('show', 'achievement');
    setTimeout(() => this.celebrationEl.classList.remove('show', 'achievement'), 2400);
  }

  update(state: HUDState): void {
    this.planesEl.textContent = state.planesLeft === Infinity ? '∞' : String(state.planesLeft);
    this.hintEl.textContent = state.hint;
    if (state.aimPower === null) {
      this.aimEl.classList.remove('show');
      this.aimFillEl.style.width = '0%';
    } else {
      this.aimEl.classList.add('show');
      this.aimFillEl.style.width = `${Math.round(state.aimPower * 100)}%`;
    }
    this.personaListEl.querySelectorAll<HTMLDivElement>('.hud-persona').forEach(el => {
      const pid = el.dataset.pid as PersonaId;
      el.classList.toggle('locked', state.lockedPersona === pid);
    });
  }
}
